export const GNZS_WIDGET_ID = 27;
export const GNZS_DEV_ACCOUNT_ID = 17563087; //30491173 // 28878712 / 17563087 //29569105 //17563087 //28830832;
export const GNZS_CLIENT_ID = "d9322b36-0001-4269-bb61-976571e8a51a";

export const PARTNERS = [
  {
    id: 27,
    name: "Генезис",
    logo: "#gnzs-1c-icon__company-logo",
    background: "#000",
    guide: "https://gnzs.ru/instructions/integration-1c-amocrm-user-guide?utm_source=widget_card_tab",
    clientId: "d9322b36-0001-4269-bb61-976571e8a51a",
  },
  {
    id: 62,
    name: "WBOX",
    logo: "#gnzs-1c-icon__wbox",
    background: "#213a7a",
    guide: "https://delomatika.com/integration1c",
    clientId: "104add5c-9e54-4c80-b1fa-76fc193a2bef",
  },
];
